import { lazy } from "react";

const MyWedding = lazy(() => import("../pages/myWedding/MyWedding"));

export const myWeddingRoutes = [
  // 마이웨딩
  { path: "/my-wedding", element: <MyWedding /> },
];
